import Pagos from '../../spa/pagos/Pagos';

export default {
  path: 'pagos',
  name: 'pagos',
  component: Pagos,
};



// WEBPACK FOOTER //
// ./src/config/router/pagos.js